import { TYPES } from '../../common/constants';

export const setFndFormData = payload => ({
  type: TYPES.SET_FND_FORM_DATA,
  payload,
});


export const clearFndFormData = () => ({
  type:TYPES.CLEAR_FND_FORM_DATA,
 })